/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './mytab.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../pages/admin/icontact/tabs/detail.component.ngfactory';
import * as i3 from 'ngx-bootstrap/modal/bs-modal.service';
import * as i4 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i5 from '../../../../app/common/services/User.service';
import * as i6 from '@angular/http';
import * as i7 from '@angular/router';
import * as i8 from '../../../../app/common/services/Organize.service';
import * as i9 from '../../../../app/common/services/Ticket.service';
import * as i10 from '../../../../app/pages/admin/icontact/tabs/detail.component';
import * as i11 from 'ngx-toastr';
import * as i12 from '../../../../app/pages/admin/icontact/customer/UserSharedService';
import * as i13 from '../../../../app/layout/mytab/mytab.component';
import * as i14 from '../tabs/tabs.component.ngfactory';
import * as i15 from '../../../../app/common/services/Group.service';
import * as i16 from '../../../../app/common/services/Contact.service';
import * as i17 from '../../../../app/common/services/Upload.service';
import * as i18 from '../../../../app/layout/tabs/tabs.component';
import * as i19 from '../../../../app/common/services/Socket.service';
import * as i20 from '../tabs/tab.component.ngfactory';
import * as i21 from '../../../../app/layout/tabs/tab.component';
const styles_MytabComponent:any[] = [i0.styles];
export const RenderType_MytabComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MytabComponent,data:{}});
function View_MytabComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(1,
      0,(null as any),(null as any),5,'detail',([] as any[]),[[8,'id',0]],(null as any),
      (null as any),i2.View_DetailComponent_0,i2.RenderType_DetailComponent)),i1.ɵprd(512,
      (null as any),i3.BsModalService,i3.BsModalService,[i1.RendererFactory2,i4.ComponentLoaderFactory]),
      i1.ɵprd(512,(null as any),i5.UserService,i5.UserService,[i6.Http,i7.Router]),
      i1.ɵprd(512,(null as any),i8.OrganizeService,i8.OrganizeService,[i6.Http,i7.Router]),
      i1.ɵprd(512,(null as any),i9.TicketService,i9.TicketService,[i6.Http,i7.Router]),
      i1.ɵdid(6,2342912,(null as any),0,i10.DetailComponent,[i1.ChangeDetectorRef,
          i11.ToastrService,i3.BsModalService,i5.UserService,i8.OrganizeService,i9.TicketService,
          i12.UserSharedService],{data:[0,'data'],tabIndex:[1,'tabIndex']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    const currVal_1:any = _v.context.data;
    const currVal_2:any = _v.context.tabIndex;
    _ck(_v,6,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵinlineInterpolate(1,'tab-',_v.context.tabIndex,'');
    _ck(_v,1,0,currVal_0);
  });
}
export function View_MytabComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{detailTemplate:0}),i1.ɵqud(402653184,2,{tabsComponent:0}),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),12,'my-tabs',([] as any[]),(null as any),
          [[(null as any),'clickTabFirst']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i13.MytabComponent = _v.component;
            if (('clickTabFirst' === en)) {
              const pd_0:any = ((<any>_co.openNew($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i14.View_TabsComponent_0,i14.RenderType_TabsComponent)),i1.ɵprd(512,(null as any),
          i5.UserService,i5.UserService,[i6.Http,i7.Router]),i1.ɵprd(512,(null as any),
          i9.TicketService,i9.TicketService,[i6.Http,i7.Router]),i1.ɵprd(512,(null as any),
          i8.OrganizeService,i8.OrganizeService,[i6.Http,i7.Router]),i1.ɵprd(512,(null as any),
          i15.GroupService,i15.GroupService,[i6.Http,i7.Router]),i1.ɵprd(512,(null as any),
          i16.ContactService,i16.ContactService,[i6.Http,i7.Router,i17.UploadService]),
      i1.ɵdid(8,3391488,[[2,4]],1,i18.TabsComponent,[i1.ChangeDetectorRef,i11.ToastrService,
          i3.BsModalService,i1.ComponentFactoryResolver,i5.UserService,i9.TicketService,
          i19.SocketService,i8.OrganizeService,i15.GroupService,i16.ContactService,
          i12.UserSharedService],(null as any),{clickTabFirst:'clickTabFirst'}),i1.ɵqud(603979776,
          3,{tabs:1}),(_l()(),i1.ɵted(-1,0,['\n  '])),(_l()(),i1.ɵeld(11,0,(null as any),
          0,2,'my-tab',([] as any[]),(null as any),(null as any),(null as any),i20.View_TabComponent_0,
          i20.RenderType_TabComponent)),i1.ɵdid(12,49152,[[3,4]],0,i21.TabComponent,
          ([] as any[]),{title:[0,'title']},(null as any)),(_l()(),i1.ɵted(-1,0,['\n  '])),
      (_l()(),i1.ɵted(-1,0,['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵand(0,[[1,2],['detailTemplate',2]],(null as any),0,(null as any),View_MytabComponent_1))],
      (_ck,_v) => {
        _ck(_v,8,0);
        const currVal_0:any = 'Thêm';
        _ck(_v,12,0,currVal_0);
      },(null as any));
}
export function View_MytabComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'my_tabs',([] as any[]),
      (null as any),(null as any),(null as any),View_MytabComponent_0,RenderType_MytabComponent)),
      i1.ɵdid(1,49152,(null as any),0,i13.MytabComponent,[i19.SocketService,i9.TicketService],
          (null as any),(null as any))],(null as any),(null as any));
}
export const MytabComponentNgFactory:i1.ComponentFactory<i13.MytabComponent> = i1.ɵccf('my_tabs',
    i13.MytabComponent,View_MytabComponent_Host_0,{force_new_tab:'force_new_tab'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvbGF5b3V0L215dGFiL215dGFiLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2xheW91dC9teXRhYi9teXRhYi5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2xheW91dC9teXRhYi9teXRhYi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvbGF5b3V0L215dGFiL215dGFiLmNvbXBvbmVudC50cy5NeXRhYkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxteS10YWJzIChjbGlja1RhYkZpcnN0KT1cIm9wZW5OZXcoJGV2ZW50KVwiPlxuICA8bXktdGFiIFt0YWJUaXRsZV09XCInVGjDqm0nXCI+XG4gIDwvbXktdGFiPlxuPC9teS10YWJzPlxuPG5nLXRlbXBsYXRlICBsZXQtZGF0YT1cImRhdGFcIiBsZXQtdGFiSW5kZXg9XCJ0YWJJbmRleFwiICNkZXRhaWxUZW1wbGF0ZT5cbiAgPGRldGFpbCBbZGF0YV09XCJkYXRhXCIgW3RhYkluZGV4XT1cInRhYkluZGV4XCIgaWQ9XCJ0YWIte3t0YWJJbmRleH19XCI+PC9kZXRhaWw+XG48L25nLXRlbXBsYXRlPiIsIjxteV90YWJzPjwvbXlfdGFicz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0lzRSw0Q0FDcEU7TUFBQTtNQUFBO01BQUE7YUFBQTthQUFBO2FBQUE7YUFBQTs7K0JBQUE7TUFBMkU7SUFBbkU7SUFBYztJQUF0QixXQUFRLFVBQWMsU0FBdEI7O0lBQTRDO0lBQTVDLFdBQTRDLFNBQTVDOzs7OztNQUxGO1VBQUE7WUFBQTtZQUFBO1lBQVM7Y0FBQTtjQUFBO1lBQUE7WUFBVDtVQUFBO3dDQUFBOzRDQUFBO2dEQUFBOzRDQUFBO2dEQUFBO2FBQUE7OzsrQkFBQTtVQUFBLFlBQTJDLGdDQUN6QztVQUFBO3FDQUFBLFVBQUE7VUFBQSxpREFBNEI7TUFDbkIsOEJBQ0QsMENBQ1Y7aUJBQUE7O1FBSkE7UUFDVTtRQUFSLFlBQVEsU0FBUjs7OztvQkNERjtNQUFBO2FBQUE7VUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/layout/mytab/mytab.component.ngfactory.ts